import React from 'react'
import type { FormControlLabelProps as MuiFormControlLabelProps } from '@material-ui/core/FormControlLabel'
import MuiFormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, FormControlLabelProps>((theme) => ({
  root: {
    ...theme.typography.body1
  }
}))

export interface FormControlLabelProps extends MuiFormControlLabelProps {
  classes?: MuiFormControlLabelProps['classes'] & StyleClasses<typeof useStyles>
}

const FormControlLabel = React.forwardRef(function FormControlLabel(props: FormControlLabelProps, ref) {
  const classes = useStyles(props)
  return <MuiFormControlLabel {...props} classes={classes} ref={ref} />
})

export default FormControlLabel
